export interface SubLink {
    name: string;
    targetId: string;
    previewImage: string;
}

interface MenuItem {
    targetId: string;
    subLinks: SubLink[];
}

export interface MenuData {
    [key: string]: MenuItem;
}

const menuData: MenuData = {
    'THE CLUB EXPERIENCE': {
        targetId: '',
        subLinks: [
            {name: 'Sports Facilities', targetId: 'sports-facilities', previewImage: '/images/swimming_1.webp'},
            {name: 'Lifestyle & Wellness', targetId: 'lifestyle-and-wellness', previewImage: '/images/meditation.jpg'},
            {name: 'Restaurants & Bar', targetId: 'restaurants-and-bars', previewImage: '/images/restaurant_1.webp'},
            {name: 'Junior Engagement', targetId: 'junior-engagement', previewImage: '/images/gaming_1.webp'},
            {name: 'Hospitality', targetId: 'hospitality', previewImage: '/images/room_1.webp'},
        ],
    },
    'ABOUT': {
        targetId: 'about',
        subLinks: [],
    },
    'MEMBERSHIP': {
        targetId: 'membership',
        subLinks: [],
    },
    'CONNECT': {
        targetId: 'connect',
        subLinks: [],
    }
};

export default menuData;